import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';

export default function NewsBrief() {
  const items = newsList.slice(0, 3);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 animate-fade-up md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
            <i className="ri-newspaper-line"></i>
          </span>
          <h2 className="font-heading text-lg font-bold text-foreground-950">影视快讯</h2>
        </div>
        <Link to="/news" className="text-xs font-medium text-primary-600 hover:text-primary-700">
          全部资讯
        </Link>
      </div>
      <ul className="flex flex-col divide-y divide-background-200">
        {items.map((news) => (
          <li key={news.id}>
            <Link to={`/news/${news.id}`} className="group block py-3">
              <h3 className="line-clamp-2 text-sm font-medium text-foreground-900 group-hover:text-primary-600">
                {news.title}
              </h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">{news.summary}</p>
              <p className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-400">
                <span>{news.source}</span>
                <span className="text-background-400">·</span>
                <span>{news.date}</span>
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}